export default __webpack_public_path__ + "media/images/icons/icon-social-ytube-0fdfa9f15060d2b83f6338e487ab4e1a.svg";